export default __webpack_public_path__ + "static/media/pdf_download.35ff7778.svg";